(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VesselDialogController', VesselDialogController);

    VesselDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Vessel'];

    function VesselDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Vessel) {
        var vm = this;

        vm.vessel = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vessel.id !== null) {
                Vessel.update(vm.vessel, onSaveSuccess, onSaveError);
            } else {
                Vessel.save(vm.vessel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:vesselUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
